<template>
  <div class="row animated fadeIn step-container">
    <div class="col-md-8 offset-md-2 step-body clinic-leave-wrapper">
      <h4 class="step-header">
        <div v-if="isEditMode" class='title'>{{$t('message.leave.title_edit')}}</div>
        <div v-else class='title'>{{$t('message.leave.title_add')}}</div>
      </h4>
      <div v-if="preLoaded" class='leave-form'>
        <div v-if="$guser.isClinic() || $guser.isClinicMulti()">
          <label>{{$t('message.leave.doctor')}}</label>
          <multiselect id="doctor" 
                  class="multi-select-form"
                  v-model="leave.doctor" 
                  :placeholder="$t('message.leave.doctor_placeholder')" 
                  :options="doctor_options"
                  :allow-empty="true"
                  :disabled="isEditMode"
                  selected-label="" 
                  select-label="" 
                  deselect-label=""
                  label="label" 
                  track-by="label"></multiselect>
          <error-box :message="frmError.doctor_id"/>
          <div class="add-padding-bottom" />
        </div>

        <div v-if="$guser.isClinic() || $guser.isClinicMulti()" class="form-divider"></div>
        <div>
          <div class="allDayCheckBox">
            <div class="squaredThree">
              <input type="checkbox" value="None" id="allday" v-model="leave.all_day"/>
              <label for="allday"></label>
            </div>
            <span class="allDayLabel">{{$t('message.leave.all_time')}}</span>
          </div>
          <br>
          
          <label>{{$t('message.leave.leave_date')}}</label>
          <div class="row">
            <div class="col-sm-4">
              <flat-pickr v-model='selectedDateTime.start_date' 
                      :placeholder="$t('message.leave.leave_date_placeholder')" 
                      :config="fpConfig"
                      class="flatpickr-input"/>
            </div>
            <div v-if="!leave.all_day" class="col-sm-3">
              <flat-pickr v-model='selectedDateTime.start_time'
                    :placeholder="$t('message.leave.leave_time_placeholder')"
                    :config="fpTimeConfig"
                    class="flatpickr-input"/>
            </div>
          </div>
          <error-box :message="frmError.start_time"/>

          <label>{{$t('message.leave.to')}}</label>
          <div class="row">
            <div class="col-sm-4">
              <flat-pickr v-model='selectedDateTime.end_date' 
                      :placeholder="$t('message.leave.leave_date_placeholder')" 
                      :config="fpConfig"
                      class="flatpickr-input"/>
            </div>
            <div v-if="!leave.all_day" class="col-sm-3">
              <flat-pickr v-model='selectedDateTime.end_time' 
                    :placeholder="$t('message.leave.leave_time_placeholder')"
                    :config="fpTimeConfig"
                    class="flatpickr-input"/>
            </div>
          </div>
          <error-box :message="frmError.end_time"/>
        </div>

        <div class="form-divider"></div>

        <bs-input type="textarea" :label="$t('message.leave.remark')" v-model="leave.description" :placeholder="$t('message.leave.remark')"></bs-input>

        <div class="row">
          <div class="col-12 form-group">
            <button class="btn btn-lg btn-close" @click="cancelLeave">{{$t('action_message.cancel')}}</button>
            <button class="btn btn-add btn-lg btn-success" @click="addLeave">{{ isEditMode ? $t('action_message.edit'): $t('action_message.add') }}</button>
            <div v-show='loading' class='btn btn-sm'><sync-loader size='10px'></sync-loader></div>
            <button v-if="isEditMode" class="btn btn-add btn-lg btn-danger remove-leave-action" @click="removeLeave">{{$t('action_message.remove')}}</button>
          </div>
        </div>
      </div>
      <div v-else class='btn btn-sm text-center detail-loader'><sync-loader size='10px'></sync-loader></div>
    </div>
  </div>
</template>

<script>
import { input as BsInput } from 'vue-strap'
import ErrorBox from '@/components/ErrorMessageBox'
import SyncLoader from 'vue-spinner/src/SyncLoader'
import FlatPickr from 'vue-flatpickr-component'
import ThFP from 'flatpickr/dist/l10n/th.js'
import Multiselect from 'vue-multiselect'
import moment from 'moment'

export default {
  props: {
    id: {
      type: String,
      default: null
    },
    doctor_id: {
      type: String,
      default: null
    }
  },
  components: {
    BsInput,
    ErrorBox,
    SyncLoader,
    FlatPickr,
    Multiselect
  },
  data () {
    let defaultleave = {
      doctor: null,
      clinic_id: (this.$guser.isClinic() || this.$guser.isClinicMulti()) ? this.$guser.user.clinic.id : null,
      doctor_id: (this.$guser.isDoctor()) ? this.$guser.user.doctor.id : null,
      start_time: null,
      end_time: null,
      description: '',
      all_day: false
    }

    let formDefaultError = {
      doctor_id: this.$t('message.leave.doctor_require'),
      start_time: this.$t('message.leave.time_require'),
      end_time: this.$t('message.leave.time_require'),
      invalid_time: this.$t('message.leave.time_invalid')
    }

    let formCleanError = {
      doctor_id: null,
      start_time: null,
      end_time: null,
      invalid_time: null
    }

    return {
      defaultleave,
      formDefaultError,
      formCleanError,
      loading: false,
      preLoaded: false,
      frmError: Object.assign({}, formCleanError),
      leave: Object.assign({}, defaultleave),
      selectedDateTime: {
        start_date: null,
        start_time: '0000-00-00 00:00',
        end_date: null,
        end_time: '0000-00-00 00:00'
      },
      doctor_options: [],
      fpConfig: {
        defaultHour: 8,
        defaultMinute: 0,
        altFormat: 'j M Y',
        altInput: true,
        enableTime: false,
        dateFormat: 'Y-m-d H:i',
        locale: (this.$i18n.locale === 'th') ? ThFP.th : null
      },
      fpTimeConfig: {
        defaultHour: 8,
        defaultMinute: 0,
        altFormat: 'H:i',
        altInput: true,
        enableTime: true,
        time_24hr: true,
        noCalendar: true,
        dateFormat: 'Y-m-d H:i',
        locale: (this.$i18n.locale === 'th') ? ThFP.th : null
      }
    }
  },
  computed: {
    isEditMode () {
      return this.id !== null
    }
  },
  methods: {
    back () {
      this.$router.go(-1)
    },
    cancelLeave () {
      this.$router.go(-1)
    },
    async removeLeave (leave) {
      if (await this.$confirm(this.$t('action_message.are_you_sure'))) {
        this.$http.delete(`${this.$APP_CONFIG.api.admin.timeoffs()}/${this.id}`,
          {
            credentials: true,
            headers: { 'content-type': 'application/json' }
          }).then(res => {
            this.refreshLeave()
            this.back()
          })
      }
    },
    addLeave () {
      if (this.isEditMode) {
        this.updateLeave()
      } else {
        this.clearFormError()
        // All day
        if (this.leave.all_day) {
          this.leave.start_time = this.selectedDateTime.start_date
          this.leave.end_time = this.selectedDateTime.end_date
        } else {
          this.leave.start_time = this.selectedDateTime.start_date.substr(0, 10) + ' ' + this.selectedDateTime.start_time.substr(this.selectedDateTime.start_time.length - 5, 5)
          this.leave.end_time = this.selectedDateTime.end_date.substr(0, 10) + ' ' + this.selectedDateTime.end_time.substr(this.selectedDateTime.start_time.length - 5, 5)
        }

        var leave = Object.assign({}, this.leave)

        if (!this.checkValidForm()) {
          return
        }
        if (this.$guser.isClinic() || this.$guser.isClinicMulti()) {
          leave.doctor_id = leave.doctor.value
        } else {
          leave.doctor_id = this.$guser.user.doctor.id
        }

        this.processTime()
        delete leave.doctor
        this.$http.post(this.$APP_CONFIG.api.admin.timeoffs(),
          // data
          leave,
          // options
          {
            credentials: true,
            headers: { 'content-type': 'application/json' }
          }).then(res => {
            if (res.body.id) {
              this.refreshLeave()
              this.back()
            }
          },
          error => {
            if (error.body.error) {
              this.showFormFromError(error.body.error)
            }
          })
      }
    },
    updateLeave () {
      this.clearFormError()

      // All day
      if (this.leave.all_day) {
        this.leave.start_time = this.selectedDateTime.start_date
        this.leave.end_time = this.selectedDateTime.end_date
      } else {
        this.leave.start_time = this.selectedDateTime.start_date.substr(0, 10) + ' ' + this.selectedDateTime.start_time.substr(this.selectedDateTime.start_time.length - 5, 5)
        this.leave.end_time = this.selectedDateTime.end_date.substr(0, 10) + ' ' + this.selectedDateTime.end_time.substr(this.selectedDateTime.start_time.length - 5, 5)
      }

      var leave = Object.assign({}, this.leave)
      if (!this.checkValidForm()) {
        return
      }
      // remove unnecsessary fields
      if (this.$guser.isClinic() || this.$guser.isClinicMulti()) {
        leave.doctor_id = leave.doctor.value
      } else {
        leave.doctor_id = this.$guser.user.doctor.id
      }
      this.processTime()
      delete leave.updated_at
      delete leave.created_at
      delete leave.doctor

      this.$http.put(`${this.$APP_CONFIG.api.admin.timeoffs()}/${this.id}`,
        // data
        this.leave,
        // options
        {
          credentials: true,
          headers: { 'content-type': 'application/json' }
        }).then(res => {
          if (res.body.id) {
            this.refreshLeave()
            this.back()
          }
        },
        error => {
          if (error.body.error) {
            this.showFormFromError(error.body.error)
          }
        })
    },
    async refreshLeave () {
      /* if ((this.$guser.isClinic() && (!this.id || !this.doctor_id)) ||
          (this.$guser.isDoctor() && (!this.id))) {
        this.preLoaded = true
        return
      } */
      if (this.$guser.isDoctor() && (!this.id)) {
        this.preLoaded = true
        return
      }

      var params = {ref_clinic_id: this.$route.query.ref_clinic_id}
      if (this.$guser.isClinic() || this.$guser.isClinicMulti()) {
        params.clinic_id = this.$guser.user.clinic.id
        params.doctor_id = this.doctor_id
      } else {
        params.doctor_id = this.$guser.user.doctor.id
      }

      var self = this
      var res = await this.$http.get(this.$APP_CONFIG.api.admin.timeoffs(), {
        params: params,
        credentials: true
      })

      if (res) {
        if (res.body) {
          var doctorId = null
          if (this.$guser.isClinic() || this.$guser.isClinicMulti()) {
            doctorId = +self.doctor_id
          } else {
            doctorId = +self.$guser.user.doctor.id
          }
          var leaveInfo = res.body.find(_l => _l.id === +self.id && _l.doctor_id === doctorId)
          if (leaveInfo) {
            self.leave = Object.assign({}, leaveInfo, {
              doctor: self.doctor_options.find(_d => _d.value === doctorId)
            })

            this.selectedDateTime.start_time = leaveInfo.start_time.substr(0, leaveInfo.start_time.length - 3)
            this.selectedDateTime.start_date = leaveInfo.start_time.substr(0, leaveInfo.start_time.length - 3)
            this.selectedDateTime.end_time = leaveInfo.end_time.substr(0, leaveInfo.end_time.length - 3)
            this.selectedDateTime.end_date = leaveInfo.end_time.substr(0, leaveInfo.end_time.length - 3)
          }
          this.preLoaded = true
        }
      }
    },
    processTime () {
      var spltTime = null
      if (this.leave.start_time) {
        spltTime = this.leave.start_time.split(':')
        if (spltTime.length > 2) {
          this.leave.start_time = spltTime[0] + ':' + spltTime[1]
        }
      }
      if (this.leave.end_time) {
        spltTime = this.leave.end_time.split(':')
        if (spltTime.length > 2) {
          this.leave.end_time = spltTime[0] + ':' + spltTime[1]
        }
      }
    },
    clearFormError () {
      this.frmError = Object.assign({}, this.formCleanError)
    },
    showFormFromError (error) {
      if (error) {
        this.frmError.doctor_id = this.getMessageFromError(error.doctor_id)
        this.frmError.start_time = this.getMessageFromError(error.start_time)
        this.frmError.end_time = this.getMessageFromError(error.end_time)
      }
    },
    getMessageFromError (errorObj) {
      var message = null
      if (errorObj && Array.isArray(errorObj)) {
        message = errorObj.join(' ')
      } else {
        message = errorObj
      }
      return message
    },
    checkValidForm () {
      let defaultFrmError = this.formDefaultError
      if (this.$guser.isClinic() && !this.leave.doctor) {
        this.frmError.doctor_id = defaultFrmError.doctor_id
        return false
      }
      // if (!this.leave.start_time) {
      if (!this.selectedDateTime.start_date && this.leave.all_day) {
        this.frmError.start_time = defaultFrmError.start_time
        return false
      }
      // Time
      if ((!this.selectedDateTime.start_time || !this.selectedDateTime.start_date) && !this.leave.all_day) {
        this.frmError.start_time = defaultFrmError.start_time
        return false
      }

      // if (!this.leave.end_time) {
      if (!this.selectedDateTime.end_date && this.leave.all_day) {
        this.frmError.end_time = defaultFrmError.end_time
        return false
      }

      // Time
      if ((!this.selectedDateTime.end_time || !this.selectedDateTime.end_date) && !this.leave.all_day) {
        this.frmError.end_time = defaultFrmError.end_time
        return false
      }

      if (moment(this.leave.end_time).diff(moment(this.leave.start_time), 'minutes') <= 0) {
        this.frmError.end_time = defaultFrmError.invalid_time
        return false
      }
      return true
    },
    async loadDoctors () {
      var params = {
        disable_pagination: 1
      }
      if (this.$guser.isClinic() || this.$guser.isClinicMulti()) {
        params.clinic_id = this.$guser.user.clinic.id
      } else {
        params.doctor_id = this.$guser.user.doctor.id
      }
      // get doctor list for this clinic to be calendar resources and drop list options used when create new appointment
      let dtList = await this.$http.get(this.$APP_CONFIG.api.admin.doctors(), { params: params })
      if (dtList) {
        // add to calendar resource
        this.doctor_options = []
        dtList.body.data.forEach(d => {
          this.doctor_options.push({
            label: (this.$i18n.locale === 'th') ? d.name_th : d.name_en,
            value: d.id
          })
        })
      }
    },
    async initData () {
      if (this.$guser.isClinic() || this.$guser.isClinicMulti()) {
        await this.loadDoctors()
      }
      await this.refreshLeave()
    }
  },
  created () {
    this.initData()
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang='scss'>
@import "../../../assets/base_container";

.input-min {
  width: 200px;
}

.leave-container {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  background-color: #fafafa;
  border: 1px solid #ddd;
  margin-bottom: 0.5em;
  border-radius: 5px;
  
  h6 {
    margin: 0;
  }
  
  .leave-content {
    flex: 2; 
    padding: 0.5rem;
    border-right: 1px solid #ddd;
  }

  .leave-actions {
    padding: 1em;
    text-align: center;
  }
}

.remove-leave-action {
  float: right;
}

.allDayCheckBox {
  display: flex;
}

.allDayLabel {
  margin-left: 1.5rem;
}

.detail-loader {
  width: 100%;
}

</style>



// WEBPACK FOOTER //
// LeaveDetail.vue?bde8adf0